import { render, staticRenderFns } from "./ApplyReason.vue?vue&type=template&id=242288bc&scoped=true"
import script from "./ApplyReason.vue?vue&type=script&lang=js"
export * from "./ApplyReason.vue?vue&type=script&lang=js"
import style0 from "./ApplyReason.vue?vue&type=style&index=0&id=242288bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242288bc",
  null
  
)

export default component.exports